// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tw-card.--dark-mode[data-v-50806398]{background:#242526;color:#fff}.tw-card.--dark-mode .text-gray-500[data-v-50806398]{color:#9d9d9d}.tw-card.--dark-mode .text-primary[data-v-50806398]{color:#fff}.tw-card.--rounded[data-v-50806398]{border-radius:7px}", ""]);
// Exports
module.exports = exports;
